import * as es from '../locales/es/es.json'
import get from 'lodash.get'

export const translate = <T extends object>(
  key: string,
  data?: T,
  fallback?: string
): string => {
  const word = get(es, key)

  if (!word && fallback) return fallback

  const regex = /{{\s*([^{}]+)\s*}}/g

  const final = word || key || ''

  //@ts-ignore
  return final.replace(regex, (_, match) => String(get(data, match))) || key
}
